const KEY = 'zeigbanner.guest';

export interface GuestIdentity {
  name: string;
  email?: string;
}

export function loadGuest(): GuestIdentity | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw) as GuestIdentity;
    return data.name ? data : null;
  } catch {
    return null;
  }
}

export function saveGuest(identity: GuestIdentity): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(identity));
  } catch {
    // privater Modus o. ä. – dann eben nur für diese Sitzung
  }
}
